import React, { useEffect } from 'react';
import { Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import capitalize from '../../../../../../Hooks/capitalize';
// import applicantsService from '../../../../../../Services/applicantsService';
// import { useNavigate } from 'react-router-dom';
// import toast from 'react-hot-toast';
// import { base64, sha256 } from 'crypto';
function ReviewALLDocument (props: any) {
  const [hasFirstDegree, setHasFirstDegree] = React.useState<boolean>(false);
  const [showModal, setShowModal] = React.useState<boolean>(false);
  const [showFullImage, setShowFullImage] = React.useState<string>('');
  // console.log('HHHH', props)
  //   console.log('preview data in review all doc', props.previewData.dataset.institutionDetails.degreeTitle);
  //   console.log('preview data in review all doc full', props.previewData.dataset.formData);
  const checkFirstDegree = () => {
    if (!props?.previewData.dataset.formData?.institutionDetails) {
      return null
    }
    if (
      props?.previewData.dataset.formData?.institutionDetails[0].first_degreeTitle &&
      props.previewData.dataset.formData?.institutionDetails[0].first_institutionName &&
      props.previewData.dataset.formData?.institutionDetails[0]
        .first_degreeCertificateNumber &&
      props.previewData.dataset.formData?.institutionDetails[0].first_degreeAwarded &&
      props.previewData.dataset.formData?.institutionDetails[0].first_graduationYear
    ) {
      setHasFirstDegree(true);
    }
  };
  useEffect(() => {
    checkFirstDegree();
  }, []);

  const firstSittingObj = props.previewData?.dataset?.formData?.firstSitting ?? {};
  // const firstSittingPairs = Object.keys(firstSittingObj)
  //   .filter((k) => /^subject\d+$/.test(k))
  //   .map((k) => {
  //     const idx = k.match(/\d+$/)?.[0] ?? '';
  //     return {
  //       subject: firstSittingObj[k],
  //       grade: firstSittingObj[`grade${idx}`],
  //     };
  //   });

  const secondSittingObj = props.previewData?.dataset?.formData?.secondSitting ?? {};
  // const secondSittingPairs = Object.keys(secondSittingObj)
  //   .filter((k) => /^subject\d+$/.test(k))
  //   .map((k) => {
  //     const idx = k.match(/\d+$/)?.[0] ?? '';
  //     return {
  //       subject: secondSittingObj[k],
  //       grade: secondSittingObj[`grade${idx}`],
  //     };
  //   });

  // Helper function to process and sort the data
  const processAndSort = (dataObj: any) => {
    return Object.keys(dataObj)
      .filter((k) => /^subject\d+$/.test(k)) // Filter for keys like "subject1"
      .map((k) => {
        const idxStr = k.match(/\d+$/)?.[0] ?? '0'; // Extract "1" from "subject1"
        return {
          id: parseInt(idxStr, 10), // Convert to number for sorting
          subject: dataObj[k],
          grade: dataObj[`grade${idxStr}`],
        };
      })
      .sort((a, b) => a.id - b.id); // Sort: 1, 2, 3...
  };

  const firstSittingPairs = processAndSort(firstSittingObj);
  const secondSittingPairs = processAndSort(secondSittingObj);
  return (
   <>{ props.previewData.dataset !== undefined && <div>
      <div className=' p-1'>
        <h3 className='sub-heading__pinfo mb-2'>
          <span className='stage_header'>Document Upload</span>
        </h3>
      </div>
      {props.previewData.dataset.formData.sscedetails.map((value: any, index: any) => {
        return (
          <div
            className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'
            key={index}
          >
            <div className='review-row col'>
              <span className='review-label'>Exam Type(SSCE): </span>
              <span className='review-value'>{value.examType}</span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Exam Number(SSCE): </span>
              <span className='review-value'>{value.examNo}</span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Exam Year(SSCE): </span>
              <span className='review-value'>{value.examYear}</span>
            </div>
          </div>
        );
      })}
      {hasFirstDegree && (
        <div className='p-1'>
          <div>
            <h3 className='sub-heading__pinfo '>First Degree Details</h3>
          </div>
          <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
            <div className='review-row col'>
              <span className='review-label'>Degree Title:</span>
              <span className='review-value'>
                {
                  props.previewData.dataset.formData.institutionDetails[0]
                    .first_degreeTitle
                }
              </span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Institution Name:</span>
              <span className='review-value'>
                {
                  props.previewData.dataset.formData.institutionDetails[0]
                    .first_institutionName
                }
              </span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Degree Certificate Number:</span>
              <span className='review-value'>
                {
                  props.previewData.dataset.formData.institutionDetails[0]
                    .first_degreeCertificateNumber
                }
              </span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Degree Awarded:</span>
              <span className='review-value'>
                {
                  props.previewData.dataset.formData.institutionDetails[0]
                    .first_degreeAwarded
                }
              </span>
            </div>
            <div className='review-row col'>
              <span className='review-label'>Graduation Year:</span>
              <span className='review-value'>
                {
                  props.previewData.dataset.formData.institutionDetails[0]
                    .first_graduationYear
                }
              </span>
            </div>
          </div>
        </div>
      )}
      {(props.previewData.dataset.formData.institutionDetails && props.previewData.dataset.formData.institutionDetails[0].degreeTitle !== '' && (props.previewData.dataset.formData.candidateRole === 'sp-asp-insp' || props.previewData.dataset.formData.candidateRole === 'sp-asp2-insp2')) && <div className='p-1'>
        <div>
          <h3 className='sub-heading__pinfo '>Degree Details</h3>
        </div>
        <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>
          {props.previewData.dataset.formData.institutionDetails.map((institution: any, index: number) => {
            return <><div className='review-row col' key={index}>
            <span className='review-label'>Degree Title:</span>
            <span className='review-value'>
              {institution.degreeTitle}
            </span>
          </div>
          <div className='review-row col'>
            <span className='review-label'>Institution Name:</span>
            <span className='review-value'>
              {institution.institutionName}
            </span>
          </div>
          <div className='review-row col'>
            <span className='review-label'>Degree Certificate Number:</span>
            <span className='review-value'>
              {
                institution.degreeCertificateNumber
              }
            </span>
          </div>
          <div className='review-row col'>
            <span className='review-label'>Degree Awarded:</span>
            <span className='review-value'>
              {institution.degreeAwarded}
            </span>
          </div>
          <div className='review-row col'>
            <span className='review-label'>Graduation Year:</span>
            <span className='review-value'>
              {institution.graduationYear}
            </span>
          </div>
          </>
          })
      }
        </div>
      </div>}
    <div className='p-1 d-none'>
      <div>
        <h3 className='sub-heading__pinfo '>Uploaded Documents</h3>
      </div>
      <div className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'>

      { (props.previewData === undefined || props.previewData.document === undefined)
        ? <div className='col-lg-12 '><b>Document Processing in Progress:</b> Your uploaded document has been received and is currently in the synchronization queue. Our system is verifying the data and updating your records. This typically takes a few moments. Please refresh or check back shortly.</div>
        : Object.entries(props.previewData.document.formSubmission)
        // 1. FILTER: Only keep items that are marked as uploaded in manifestInfo
          .filter(([key, value]) => {
            if (key === 'lgaCertificate') {
              if (props.manifestInfo?.lgaCertificate) {
                return props.manifestInfo.lgaCertificate.upload === true;
              }
              return props.manifestInfo?.lgaCertificate?.upload === true;
            }
            return props.manifestInfo?.[key]?.upload === true;
          })
        // 2. MAP: Render the remaining items
          .map(([key, value]) => {
            return (
      <div className='review-row col' key={key}>
        <div className='review-label'>
          {/* Formats "camelCase" to "Camel Case" */}
          {key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())}:
        </div>

        <div className=''>
          <img
            src={value as string}
            width={150}
            height={150}
            alt={key} // Good practice to add alt text
            style={{ objectFit: 'cover' }} // Keeps image from stretching weirdly
          />
        </div>

        <div>
          <button
            className='btn btn-success'
            type='button'
            onClick={() => {
              setShowFullImage(value as string);
              setShowModal(true);
            }}
          >
            View
          </button>
        </div>
      </div>
            );
          })}
      </div>
    </div>
      <Modal show={showModal} size='lg' onHide={() => setShowModal(false)} >
        <ModalBody className='d-flex justify-content-center'>
          <img src={showFullImage} width={500} height={500} />
        </ModalBody>
        <ModalFooter>
          <button className='btn btn-success' onClick={() => setShowModal(false)}>Close</button>
        </ModalFooter>
      </Modal>

          <div className='p-1'>
        <div>
        <h3 className='sub-heading__pinfo '>SSCE Results</h3>
      </div>
        <div>
        First Sitting Results:
        {firstSittingPairs.map(({ subject, grade }, index) => {
          return (
            <div
              className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'
              key={index}
            >
              <div className='review-row col'>
                <span className='review-label'>Subject:</span>
                <span className='review-value'> { capitalize(subject)}</span>
              </div>
              <div className='review-row col'>
                <span className='review-label'>Grade:</span>
                <span className='review-value'> { capitalize(grade)}</span>
              </div>
            </div>
          );
        })}
        </div>
        <div className='my-4'>
        {props.previewData.dataset.formData.sscedetails.length > 1 && 'Second Sitting Results:'}
        {secondSittingPairs.map(({ subject, grade }, index) => {
          return (
            <div
              className='row row-cols-lg-3 row-cols-md-2 p-1 px-4 row-cols-2'
              key={index}
            >
              <div className='review-row col'>
                <span className='review-label'>Subject:</span>
                <span className='review-value'> { capitalize(subject)}</span>
              </div>
              <div className='review-row col'>
                <span className='review-label'>Grade:</span>
                <span className='review-value'> { capitalize(grade)}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
    </div>}</>
  );
}

export default ReviewALLDocument;
